export type Locale = 'en' | 'fr' | 'de' | 'es' | 'ja' | 'ko' | 'pt' | 'pl' | 'it' | 'zh';
export const locales = ['en', 'fr', 'de', 'es', 'ja', 'ko', 'pt', 'pl', 'it', 'zh'] as const;

export const isLocale = (value?: string): value is Locale => locales.includes(value as Locale);

export const SET_LOCALE = 'SET_LOCALE';
